module.exports = __webpack_public_path__ + "media/images/view-icon-174ac2d9.svg";